function init() {

    checkIfInputsFilled();

    $(document.getElementsByClassName("tripsaver-input")).bind("keyup", function (e) {
            checkIfInputsFilled();
    });

    $(document.getElementsByClassName("tripsaver-input")).bind("keydown", function (e) {
            checkInputValues(e);
    });

}

function checkIfInputsFilled() {
    var textboxes = document.getElementsByClassName("tripsaver-input");
    var calculateButton = document.getElementById("Calculator_calculateButton");

    for (var i = 0; i < textboxes.length; i++) {
        if (textboxes[i].value.length === 0) {
            calculateButton.disabled = true;
            return;
        }
    }
    if (calculateButton) {
        calculateButton.disabled = false;
    }
}

function checkInputValues(eventInstance) {
    eventInstance = eventInstance || window.event;
    var key = eventInstance.keyCode || eventInstance.which;
    if ((47 < key && key < 58) ||
        key === 46 ||
        key === 8 ||
        key === 9 ||
        key === 190 ||
        key === 110 ||
        (95 < key && key < 106)) {
        return true;
    } else {
        if (eventInstance.preventDefault) eventInstance.preventDefault();
        eventInstance.returnValue = false;
        return false;
    }
}


export default {
    init
}